import { put, takeLatest, all, call } from 'redux-saga/effects';

import axiosClient from '../config/axios';
import {
    LOGIN_PROGRESS, LOGIN_SUCCESS, LOGIN_FAILURE,
    LOGOUT_PROGRESS, LOGOUT_SUCCESS, LOGOUT_FAILURE,

    GET_BANK_LIST_PROGRESS, GET_BANK_LIST_SUCCESS, GET_BANK_LIST_FAILURE,
    ADD_BANK_PROGRESS, ADD_BANK_SUCCESS, ADD_BANK_FAILURE,
    EDIT_DELETE_BANK_PROGRESS, EDIT_DELETE_BANK_SUCCESS, EDIT_DELETE_BANK_FAILURE,

    GET_STORE_LIST_PROGRESS, GET_STORE_LIST_SUCCESS, GET_STORE_LIST_FAILURE,
    ADD_STORE_PROGRESS, ADD_STORE_SUCCESS, ADD_STORE_FAILURE,
    EDIT_DELETE_STORE_PROGRESS, EDIT_DELETE_STORE_SUCCESS, EDIT_DELETE_STORE_FAILURE,

    GET_UNIT_LIST_PROGRESS, GET_UNIT_LIST_SUCCESS, GET_UNIT_LIST_FAILURE,
    ADD_UNIT_PROGRESS, ADD_UNIT_SUCCESS, ADD_UNIT_FAILURE,
    EDIT_DELETE_UNIT_PROGRESS, EDIT_DELETE_UNIT_SUCCESS, EDIT_DELETE_UNIT_FAILURE,

    GET_BIN_LIST_PROGRESS, GET_BIN_LIST_SUCCESS, GET_BIN_LIST_FAILURE,
    ADD_BIN_PROGRESS, ADD_BIN_SUCCESS, ADD_BIN_FAILURE,
    EDIT_DELETE_BIN_PROGRESS, EDIT_DELETE_BIN_SUCCESS, EDIT_DELETE_BIN_FAILURE,

    GET_REJECT_LIST_PROGRESS, GET_REJECT_LIST_SUCCESS, GET_REJECT_LIST_FAILURE,
    ADD_REJECT_PROGRESS, ADD_REJECT_SUCCESS, ADD_REJECT_FAILURE,
    EDIT_DELETE_REJECT_PROGRESS, EDIT_DELETE_REJECT_SUCCESS, EDIT_DELETE_REJECT_FAILURE,

    GET_ITEM_LIST_PROGRESS, GET_ITEM_LIST_SUCCESS, GET_ITEM_LIST_FAILURE,
    ADD_ITEM_PROGRESS, ADD_ITEM_SUCCESS, ADD_ITEM_FAILURE,
    EDIT_DELETE_ITEM_PROGRESS, EDIT_DELETE_ITEM_SUCCESS, EDIT_DELETE_ITEM_FAILURE,

    GET_ACCOUNT_MANAGER_LIST_PROGRESS, GET_ACCOUNT_MANAGER_LIST_SUCCESS, GET_ACCOUNT_MANAGER_LIST_FAILURE,
    ADD_ACCOUNT_MANAGER_PROGRESS, ADD_ACCOUNT_MANAGER_SUCCESS, ADD_ACCOUNT_MANAGER_FAILURE,
    EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS, EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS, EDIT_DELETE_ACCOUNT_MANAGER_FAILURE,

    GET_CATEGORY_LIST_PROGRESS, GET_CATEGORY_LIST_SUCCESS, GET_CATEGORY_LIST_FAILURE,
    ADD_CATEGORY_PROGRESS, ADD_CATEGORY_SUCCESS, ADD_CATEGORY_FAILURE,
    EDIT_DELETE_CATEGORY_PROGRESS, EDIT_DELETE_CATEGORY_SUCCESS, EDIT_DELETE_CATEGORY_FAILURE,

    GET_TERMS_CONDITIONS_LIST_PROGRESS, GET_TERMS_CONDITIONS_LIST_SUCCESS, GET_TERMS_CONDITIONS_LIST_FAILURE,
    ADD_TERMS_CONDITIONS_PROGRESS, ADD_TERMS_CONDITIONS_SUCCESS, ADD_TERMS_CONDITIONS_FAILURE,
    EDIT_DELETE_TERMS_CONDITIONS_PROGRESS, EDIT_DELETE_TERMS_CONDITIONS_SUCCESS, EDIT_DELETE_TERMS_CONDITIONS_FAILURE,

    GET_CUSTOMER_LIST_PROGRESS, GET_CUSTOMER_LIST_SUCCESS, GET_CUSTOMER_LIST_FAILURE,
    ADD_CUSTOMER_PROGRESS, ADD_CUSTOMER_SUCCESS, ADD_CUSTOMER_FAILURE,
    EDIT_DELETE_CUSTOMER_PROGRESS, EDIT_DELETE_CUSTOMER_SUCCESS, EDIT_DELETE_CUSTOMER_FAILURE,

    GET_SUPPLIER_LIST_PROGRESS, GET_SUPPLIER_LIST_SUCCESS, GET_SUPPLIER_LIST_FAILURE,
    ADD_SUPPLIER_PROGRESS, ADD_SUPPLIER_SUCCESS, ADD_SUPPLIER_FAILURE,
    EDIT_DELETE_SUPPLIER_PROGRESS, EDIT_DELETE_SUPPLIER_SUCCESS, EDIT_DELETE_SUPPLIER_FAILURE,
    // ---------------- Settings All Exports ---------------
    GET_COMPANY_DETAILS_LIST_PROGRESS, GET_COMPANY_DETAILS_LIST_SUCCESS, GET_COMPANY_DETAILS_LIST_FAILURE,
    ADD_COMPANY_DETAILS_PROGRESS, ADD_COMPANY_DETAILS_SUCCESS, ADD_COMPANY_DETAILS_FAILURE,
    EDIT_DELETE_COMPANY_DETAILS_PROGRESS, EDIT_DELETE_COMPANY_DETAILS_SUCCESS, EDIT_DELETE_COMPANY_DETAILS_FAILURE,

    GET_DOC_NO_FORMATE_LIST_PROGRESS, GET_DOC_NO_FORMATE_LIST_SUCCESS, GET_DOC_NO_FORMATE_LIST_FAILURE,
    ADD_DOC_NO_FORMATE_PROGRESS, ADD_DOC_NO_FORMATE_SUCCESS, ADD_DOC_NO_FORMATE_FAILURE,
    EDIT_DELETE_DOC_NO_FORMATE_PROGRESS, EDIT_DELETE_DOC_NO_FORMATE_SUCCESS, EDIT_DELETE_DOC_NO_FORMATE_FAILURE,

    GET_INVOICE_SETTING_LIST_PROGRESS, GET_INVOICE_SETTING_LIST_SUCCESS, GET_INVOICE_SETTING_LIST_FAILURE,
    ADD_INVOICE_SETTING_PROGRESS, ADD_INVOICE_SETTING_SUCCESS, ADD_INVOICE_SETTING_FAILURE,
    EDIT_DELETE_INVOICE_SETTING_PROGRESS, EDIT_DELETE_INVOICE_SETTING_SUCCESS, EDIT_DELETE_INVOICE_SETTING_FAILURE,


    GET_MENU_SETTING_LIST_PROGRESS, GET_MENU_SETTING_LIST_SUCCESS, GET_MENU_SETTING_LIST_FAILURE,
    ADD_MENU_SETTING_PROGRESS, ADD_MENU_SETTING_SUCCESS, ADD_MENU_SETTING_FAILURE,
    EDIT_DELETE_MENU_SETTING_PROGRESS, EDIT_DELETE_MENU_SETTING_SUCCESS, EDIT_DELETE_MENU_SETTING_FAILURE,


    GET_INVOICE_TITLE_LIST_PROGRESS, GET_INVOICE_TITLE_LIST_SUCCESS, GET_INVOICE_TITLE_LIST_FAILURE,
    ADD_INVOICE_TITLE_PROGRESS, ADD_INVOICE_TITLE_SUCCESS, ADD_INVOICE_TITLE_FAILURE,
    EDIT_DELETE_INVOICE_TITLE_PROGRESS, EDIT_DELETE_INVOICE_TITLE_SUCCESS, EDIT_DELETE_INVOICE_TITLE_FAILURE,

    GET_PURCHASE_SETTING_LIST_PROGRESS, GET_PURCHASE_SETTING_LIST_SUCCESS, GET_PURCHASE_SETTING_LIST_FAILURE,
    ADD_PURCHASE_SETTING_PROGRESS, ADD_PURCHASE_SETTING_SUCCESS, ADD_PURCHASE_SETTING_FAILURE,
    EDIT_DELETE_PURCHASE_SETTING_PROGRESS, EDIT_DELETE_PURCHASE_SETTING_SUCCESS, EDIT_DELETE_PURCHASE_SETTING_FAILURE,

    GET_ALL_USER_MANAGEMENT_LIST_PROGRESS, GET_ALL_USER_MANAGEMENT_LIST_SUCCESS, GET_ALL_USER_MANAGEMENT_LIST_FAILURE,
    GET_USER_MANAGEMENT_LIST_PROGRESS, GET_USER_MANAGEMENT_LIST_SUCCESS, GET_USER_MANAGEMENT_LIST_FAILURE,
    ADD_USER_MANAGEMENT_PROGRESS, ADD_USER_MANAGEMENT_SUCCESS, ADD_USER_MANAGEMENT_FAILURE,
    EDIT_DELETE_USER_MANAGEMENT_PROGRESS, EDIT_DELETE_USER_MANAGEMENT_SUCCESS, EDIT_DELETE_USER_MANAGEMENT_FAILURE,

    // ------------ Purchase Export ----------
    GET_PURCHASE_INVOICE_LIST_PROGRESS, GET_PURCHASE_INVOICE_LIST_SUCCESS, GET_PURCHASE_INVOICE_LIST_FAILURE,
    ADD_PURCHASE_INVOICE_PROGRESS, ADD_PURCHASE_INVOICE_SUCCESS, ADD_PURCHASE_INVOICE_FAILURE,
    EDIT_DELETE_PURCHASE_INVOICE_PROGRESS, EDIT_DELETE_PURCHASE_INVOICE_SUCCESS, EDIT_DELETE_PURCHASE_INVOICE_FAILURE,

    GET_PURCHASE_ORDER_LIST_PROGRESS, GET_PURCHASE_ORDER_LIST_SUCCESS, GET_PURCHASE_ORDER_LIST_FAILURE,
    ADD_PURCHASE_ORDER_PROGRESS, ADD_PURCHASE_ORDER_SUCCESS, ADD_PURCHASE_ORDER_FAILURE,
    EDIT_DELETE_PURCHASE_ORDER_PROGRESS, EDIT_DELETE_PURCHASE_ORDER_SUCCESS, EDIT_DELETE_PURCHASE_ORDER_FAILURE,

    GET_PURCHASE_RETURN_LIST_PROGRESS, GET_PURCHASE_RETURN_LIST_SUCCESS, GET_PURCHASE_RETURN_LIST_FAILURE,
    ADD_PURCHASE_RETURN_PROGRESS, ADD_PURCHASE_RETURN_SUCCESS, ADD_PURCHASE_RETURN_FAILURE,
    EDIT_DELETE_PURCHASE_RETURN_PROGRESS, EDIT_DELETE_PURCHASE_RETURN_SUCCESS, EDIT_DELETE_PURCHASE_RETURN_FAILURE,


    // ------------ Sales Export ----------
    GET_DELIVERY_CHALLAN_LIST_PROGRESS, GET_DELIVERY_CHALLAN_LIST_SUCCESS, GET_DELIVERY_CHALLAN_LIST_FAILURE,
    ADD_DELIVERY_CHALLAN_PROGRESS, ADD_DELIVERY_CHALLAN_SUCCESS, ADD_DELIVERY_CHALLAN_FAILURE,
    EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS, EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS, EDIT_DELETE_DELIVERY_CHALLAN_FAILURE,

    GET_PROFORMA_INVOICE_LIST_PROGRESS, GET_PROFORMA_INVOICE_LIST_SUCCESS, GET_PROFORMA_INVOICE_LIST_FAILURE,
    ADD_PROFORMA_INVOICE_PROGRESS, ADD_PROFORMA_INVOICE_SUCCESS, ADD_PROFORMA_INVOICE_FAILURE,
    EDIT_DELETE_PROFORMA_INVOICE_PROGRESS, EDIT_DELETE_PROFORMA_INVOICE_SUCCESS, EDIT_DELETE_PROFORMA_INVOICE_FAILURE,

    GET_QUOTATION_LIST_PROGRESS, GET_QUOTATION_LIST_SUCCESS, GET_QUOTATION_LIST_FAILURE,
    ADD_QUOTATION_PROGRESS, ADD_QUOTATION_SUCCESS, ADD_QUOTATION_FAILURE,
    EDIT_DELETE_QUOTATION_PROGRESS, EDIT_DELETE_QUOTATION_SUCCESS, EDIT_DELETE_QUOTATION_FAILURE,

    GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS, GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_SUCCESS, GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_FAILURE,
    ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS, ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS, ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE,
    EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS, EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS, EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE,

    GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS, GET_PAYMENT_INVOICE_DEDUCTION_LIST_SUCCESS, GET_PAYMENT_INVOICE_DEDUCTION_LIST_FAILURE,
    ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS, ADD_PAYMENT_INVOICE_DEDUCTION_SUCCESS, ADD_PAYMENT_INVOICE_DEDUCTION_FAILURE,
    EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS, EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_SUCCESS, EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_FAILURE,

    GET_SALE_INVOICE_LIST_PROGRESS, GET_SALE_INVOICE_LIST_SUCCESS, GET_SALE_INVOICE_LIST_FAILURE,
    ADD_SALE_INVOICE_PROGRESS, ADD_SALE_INVOICE_SUCCESS, ADD_SALE_INVOICE_FAILURE,
    EDIT_DELETE_SALE_INVOICE_PROGRESS, EDIT_DELETE_SALE_INVOICE_SUCCESS, EDIT_DELETE_SALE_INVOICE_FAILURE,

    GET_SALES_ORDER_LIST_PROGRESS, GET_SALES_ORDER_LIST_SUCCESS, GET_SALES_ORDER_LIST_FAILURE,
    ADD_SALES_ORDER_PROGRESS, ADD_SALES_ORDER_SUCCESS, ADD_SALES_ORDER_FAILURE,
    EDIT_DELETE_SALES_ORDER_PROGRESS, EDIT_DELETE_SALES_ORDER_SUCCESS, EDIT_DELETE_SALES_ORDER_FAILURE,

    GET_SALES_RETURN_LIST_PROGRESS, GET_SALES_RETURN_LIST_SUCCESS, GET_SALES_RETURN_LIST_FAILURE,
    ADD_SALES_RETURN_PROGRESS, ADD_SALES_RETURN_SUCCESS, ADD_SALES_RETURN_FAILURE,
    EDIT_DELETE_SALES_RETURN_PROGRESS, EDIT_DELETE_SALES_RETURN_SUCCESS, EDIT_DELETE_SALES_RETURN_FAILURE,
    GET_CNS_LIST_SUCCESS, GET_CNS_LIST_FAILURE, GET_CNS_LIST_PROGRESS,
    ADD_CNS_SUCCESS, ADD_CNS_FAILURE, ADD_CNS_PROGRESS,
    EDIT_DELETE_CNS_SUCCESS, EDIT_DELETE_CNS_FAILURE,
    EDIT_DELETE_CNS_PROGRESS,
    GET_STATES_LIST_SUCCESS, GET_STATES_LIST_FAILURE, GET_STATES_LIST_PROGRESS,
    GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_SUCCESS, GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_FAILURE,
    GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS, ADD_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS,
    ADD_CUSTOMER_SUPPLIER_PAYMENT_FAILURE, ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS,
    EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS, EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_FAILURE,
    EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS, UPLOAD_FILE_ATTACHMENT_SUCCESS,
    UPLOAD_FILE_ATTACHMENT_FAILURE, UPLOAD_FILE_ATTACHMENT_PROGRESS,
    GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_SUCCESS,
    GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_FAILURE,
    GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS,
    GET_MAIL_SETUP_LIST_SUCCESS, GET_MAIL_SETUP_LIST_FAILURE, GET_MAIL_SETUP_LIST_PROGRESS,
    ADD_MAIL_SETUP_SUCCESS, ADD_MAIL_SETUP_FAILURE,
    ADD_MAIL_SETUP_PROGRESS, EDIT_DELETE_MAIL_SETUP_SUCCESS, EDIT_DELETE_MAIL_SETUP_FAILURE,
    EDIT_DELETE_MAIL_SETUP_PROGRESS, UPLOAD_BANK_EXCEL_SUCCESS,
    UPLOAD_BANK_EXCEL_FAILURE, UPLOAD_BANK_EXCEL_PROGRESS,

    // ========== all Reports export==========
    GET_SALES_REGISTER_REPORT_PROGRESS, GET_SALES_REGISTER_REPORT_SUCCESS, GET_SALES_REGISTER_REPORT_FAILURE,
    GET_PURCHASE_REGISTER_REPORT_PROGRESS, GET_PURCHASE_REGISTER_REPORT_SUCCESS, GET_PURCHASE_REGISTER_REPORT_FAILURE,
    GET_SALES_ORDER_HISTORY_REPORT_PROGRESS, GET_SALES_ORDER_HISTORY_REPORT_SUCCESS, GET_SALES_ORDER_HISTORY_REPORT_FAILURE,
    GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS, GET_PURCHASE_ORDER_HISTORY_REPORT_SUCCESS, GET_PURCHASE_ORDER_HISTORY_REPORT_FAILURE,
    GET_ACCOUNT_STATEMENT_REPORT_PROGRESS, GET_ACCOUNT_STATEMENT_REPORT_SUCCESS, GET_ACCOUNT_STATEMENT_REPORT_FAILURE,
    GET_PAYMENT_REGISTER_REPORT_PROGRESS, GET_PAYMENT_REGISTER_REPORT_SUCCESS, GET_PAYMENT_REGISTER_REPORT_FAILURE,
    GET_OUTSTANDING_REPORT_PROGRESS, GET_OUTSTANDING_REPORT_SUCCESS, GET_OUTSTANDING_REPORT_FAILURE,
    GET_GST_REGESTER_REPORT_PROGRESS, GET_GST_REGESTER_REPORT_SUCCESS, GET_GST_REGESTER_REPORT_FAILURE, UPLOAD_CNS_EXCEL_SUCCESS, UPLOAD_CNS_EXCEL_FAILURE, UPLOAD_CNS_EXCEL_PROGRESS, UPLOAD_ITEMS_EXCEL_SUCCESS, UPLOAD_ITEMS_EXCEL_FAILURE, UPLOAD_ITEMS_EXCEL_PROGRESS, UPLOAD_USER_EXCEL_SUCCESS, UPLOAD_USER_EXCEL_FAILURE, UPLOAD_USER_EXCEL_PROGRESS, ADD_PRINT_SETUP_SUCCESS, ADD_PRINT_SETUP_FAILURE, ADD_PRINT_SETUP_PROGRESS, EDIT_DELETE_PRINT_SETUP_SUCCESS, EDIT_DELETE_PRINT_SETUP_FAILURE, EDIT_DELETE_PRINT_SETUP_PROGRESS, GET_PRINT_SETUP_LIST_SUCCESS, GET_PRINT_SETUP_LIST_FAILURE, GET_PRINT_SETUP_LIST_PROGRESS, WATERMARK_PRINT_SETUP_SUCCESS, WATERMARK_PRINT_SETUP_FAILURE, WATERMARK_PRINT_SETUP_PROGRESS, FOOTER_PRINT_SETUP_SUCCESS, FOOTER_PRINT_SETUP_FAILURE, FOOTER_PRINT_SETUP_PROGRESS, GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE, GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE, GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE, GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE, GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, GET_DOC_NO_FORMATE_AVAILABLE_SUCCESS, GET_DOC_NO_FORMATE_AVAILABLE_FAILURE, GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS, GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_SUCCESS, GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_FAILURE, GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS, GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_SUCCESS, GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS, GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_FAILURE, GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_SUCCESS, GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_FAILURE, GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS,


    // ========== all Production export==========
    GET_PRODUCTION_LIST_PROGRESS, GET_PRODUCTION_LIST_SUCCESS, GET_PRODUCTION_LIST_FAILURE,
    ADD_PRODUCTION_PROGRESS, ADD_PRODUCTION_SUCCESS, ADD_PRODUCTION_FAILURE,
    EDIT_DELETE_PRODUCTION_PROGRESS, EDIT_DELETE_PRODUCTION_SUCCESS, EDIT_DELETE_PRODUCTION_FAILURE, GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE, GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, SIGNATURE_PRINT_SETUP_SUCCESS, SIGNATURE_PRINT_SETUP_FAILURE, SIGNATURE_PRINT_SETUP_PROGRESS, MAIL_SEND_ATTACHMENT_SUCCESS, MAIL_SEND_ATTACHMENT_FAILURE, MAIL_SEND_ATTACHMENT_PROGRESS, GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS_FAILURE, GET_NOTIFICATIONS_PROGRESS, GET_AGE_OF_UNPAID_INVOICE_SUCCESS, GET_AGE_OF_UNPAID_INVOICE_FAILURE, GET_AGE_OF_UNPAID_INVOICE_PROGRESS,


} from '../types/actionTypes';

// ============================= BIN ==============================
function* loginSaga(action) {
    try {
        const response = yield axiosClient.post('/login', action.payload);
        sessionStorage.setItem('loginUser', JSON.stringify(response.data));
        yield put({ type: LOGIN_SUCCESS, loginUser: response.data });
    } catch (error) {
        yield put({ type: LOGIN_FAILURE, payload: error.message });
    }
}

function* watchLogin() {
    yield takeLatest(LOGIN_PROGRESS, loginSaga);
}

function* logoutSaga(action) {
    try {
        const logoutSession = sessionStorage.removeItem('loginUser');
        yield put({ type: LOGOUT_SUCCESS, loginUser: logoutSession });
    } catch (error) {
        yield put({ type: LOGOUT_FAILURE, payload: error.message });
    }
}

function* watchLogout() {
    yield takeLatest(LOGOUT_PROGRESS, logoutSaga);
}

function* getMailSetupListSaga(action) {
    try {
        const response = yield axiosClient.get(`/mailSetup_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_MAIL_SETUP_LIST_SUCCESS, mailSetup: response.data });
    } catch (error) {
        yield put({ type: GET_MAIL_SETUP_LIST_FAILURE });
    }
}

function* watchGetMailSetupList() {
    yield takeLatest(GET_MAIL_SETUP_LIST_PROGRESS, getMailSetupListSaga);
}

function* addMailSetupSaga(action) {
    try {
        const response = yield axiosClient.post('/mailSetup', action.payload);
        yield put({ type: ADD_MAIL_SETUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_MAIL_SETUP_FAILURE, payload: error.message });
    }
}

function* watchAddMailSetup() {
    yield takeLatest(ADD_MAIL_SETUP_PROGRESS, addMailSetupSaga);
}

function* editDeleteMailSetup(action) {
    try {
        const response = yield axiosClient.put(`/mailSetup_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_MAIL_SETUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_MAIL_SETUP_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteMailSetup() {
    yield takeLatest(EDIT_DELETE_MAIL_SETUP_PROGRESS, editDeleteMailSetup);
}

function* getBinListSaga(action) {
    try {
        const response = yield axiosClient.get(`/bin_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_BIN_LIST_SUCCESS, bin: response.data });
    } catch (error) {
        yield put({ type: GET_BIN_LIST_FAILURE });
    }
}

function* watchGetBinList() {
    yield takeLatest(GET_BIN_LIST_PROGRESS, getBinListSaga);
}

function* addBinSaga(action) {
    try {
        const response = yield axiosClient.post('/bin', action.payload);
        yield put({ type: ADD_BIN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_BIN_FAILURE, payload: error.message });
    }
}

function* watchAddBin() {
    yield takeLatest(ADD_BIN_PROGRESS, addBinSaga);
}

function* editDeleteBin(action) {
    try {
        const response = yield axiosClient.put(`/bin_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_BIN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_BIN_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteBin() {
    yield takeLatest(EDIT_DELETE_BIN_PROGRESS, editDeleteBin);
}

// ============================= STORE ==============================

function* getStoreListSaga(action) {
    try {
        const response = yield axiosClient.get(`/bank_list?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_STORE_LIST_SUCCESS, store: response.data });
    } catch (error) {
        yield put({ type: GET_STORE_LIST_FAILURE });
    }
}

function* watchGetStoreList() {
    yield takeLatest(GET_STORE_LIST_PROGRESS, getStoreListSaga);
}

function* addStoreSaga(action) {
    try {
        const response = yield axiosClient.post('/bank', action.payload);
        yield put({ type: ADD_STORE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_STORE_FAILURE, payload: error.message });
    }
}

function* watchAddStore() {
    yield takeLatest(ADD_STORE_PROGRESS, addStoreSaga);
}

function* editDeleteStore(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/bank_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_STORE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_STORE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteStore() {
    yield takeLatest(EDIT_DELETE_STORE_PROGRESS, editDeleteStore);
}

// ----------------------UNIT-----------------------------------

function* getUnitListSaga(action) {
    try {
        const response = yield axiosClient.get(`/unit_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_UNIT_LIST_SUCCESS, unit: response.data });
    } catch (error) {
        yield put({ type: GET_UNIT_LIST_FAILURE });
    }
}

function* watchGetUnitList() {
    yield takeLatest(GET_UNIT_LIST_PROGRESS, getUnitListSaga);
}

function* addUnitSaga(action) {
    try {
        const response = yield axiosClient.post('/unit', action.payload);
        yield put({ type: ADD_UNIT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_UNIT_FAILURE, payload: error.message });
    }
}

function* watchAddUnit() {
    yield takeLatest(ADD_UNIT_PROGRESS, addUnitSaga);
}

function* editDeleteUnit(action) {
    try {
        const response = yield axiosClient.put(`/unit_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_UNIT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_UNIT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteUnit() {
    yield takeLatest(EDIT_DELETE_UNIT_PROGRESS, editDeleteUnit);
}

// ============================= BANK ==============================

function* getBankListSaga(action) {
    try {
        const response = yield axiosClient.get(`/bank_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_BANK_LIST_SUCCESS, bank: response.data });
    } catch (error) {
        yield put({ type: GET_BANK_LIST_FAILURE });
    }
}

function* watchGetBankList() {
    yield takeLatest(GET_BANK_LIST_PROGRESS, getBankListSaga);
}

function* addBankSaga(action) {
    try {
        const response = yield axiosClient.post('/bank', action.payload);
        yield put({ type: ADD_BANK_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_BANK_FAILURE, payload: error.message });
    }
}

function* watchAddBank() {
    yield takeLatest(ADD_BANK_PROGRESS, addBankSaga);
}

function* editDeleteBank(action) {
    try {
        const response = yield axiosClient.put(`/bank_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_BANK_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_BANK_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteBank() {
    yield takeLatest(EDIT_DELETE_BANK_PROGRESS, editDeleteBank);
}

// ============================= REJECT ==============================

function* getRejectListSaga(action) {
    try {
        const response = yield axiosClient.get(`/reason_list?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_REJECT_LIST_SUCCESS, reject: response.data });
    } catch (error) {
        yield put({ type: GET_REJECT_LIST_FAILURE });
    }
}

function* watchGetRejectList() {
    yield takeLatest(GET_REJECT_LIST_PROGRESS, getRejectListSaga);
}

function* addRejectSaga(action) {
    try {
        const response = yield axiosClient.post('/reason', action.payload);
        yield put({ type: ADD_REJECT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_REJECT_FAILURE, payload: error.message });
    }
}

function* watchAddReject() {
    yield takeLatest(ADD_REJECT_PROGRESS, addRejectSaga);
}

function* editDeleteReject(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/reason_edit_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_REJECT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_REJECT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteReject() {
    yield takeLatest(EDIT_DELETE_REJECT_PROGRESS, editDeleteReject);
}

// ============================= ITEM ==============================

function* getItemListSaga(action) {
    try {
        const response = yield axiosClient.get(`/items_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_ITEM_LIST_SUCCESS, item: response.data });
    } catch (error) {
        yield put({ type: GET_ITEM_LIST_FAILURE });
    }
}

function* watchGetItemList() {
    yield takeLatest(GET_ITEM_LIST_PROGRESS, getItemListSaga);
}

function* addItemSaga(action) {
    try {
        const response = yield axiosClient.post('/items', action.payload);
        yield put({ type: ADD_ITEM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_ITEM_FAILURE, payload: error.message });
    }
}

function* watchAddItem() {
    yield takeLatest(ADD_ITEM_PROGRESS, addItemSaga);
}

function* editDeleteItem(action) {
    try {
        const response = yield axiosClient.put(`/items_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_ITEM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_ITEM_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteItem() {
    yield takeLatest(EDIT_DELETE_ITEM_PROGRESS, editDeleteItem);
}

// ============================= ACCOUNT MANAGER ==============================
function* getAccountManagerListSaga(action) {
    try {
        const response = yield axiosClient.get(`/account_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_ACCOUNT_MANAGER_LIST_SUCCESS, accountManager: response.data });
    } catch (error) {
        yield put({ type: GET_ACCOUNT_MANAGER_LIST_FAILURE });
    }
}

function* watchGetAccountManagerList() {
    yield takeLatest(GET_ACCOUNT_MANAGER_LIST_PROGRESS, getAccountManagerListSaga);
}

function* addAccountManagerSaga(action) {
    try {
        const response = yield axiosClient.post('/account', action.payload);
        yield put({ type: ADD_ACCOUNT_MANAGER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_ACCOUNT_MANAGER_FAILURE, payload: error.message });
    }
}

function* watchAddAccountManager() {
    yield takeLatest(ADD_ACCOUNT_MANAGER_PROGRESS, addAccountManagerSaga);
}

function* editDeleteAccountManager(action) {
    try {
        const response = yield axiosClient.put(`/account_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_ACCOUNT_MANAGER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteAccountManager() {
    yield takeLatest(EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS, editDeleteAccountManager);
}

// ============================= TERMS & CONDITIONS ==============================
function* getTermsConditionsListSaga(action) {
    try {
        const response = yield axiosClient.get(`/termConditions?companyId=${action.payload.companyId}&&terms=${action.payload.terms}`);
        yield put({ type: GET_TERMS_CONDITIONS_LIST_SUCCESS, termsConditions: response.data });
    } catch (error) {
        yield put({ type: GET_TERMS_CONDITIONS_LIST_FAILURE });
    }
}

function* watchGetTermsConditionsList() {
    yield takeLatest(GET_TERMS_CONDITIONS_LIST_PROGRESS, getTermsConditionsListSaga);
}

function* addTermsConditionsSaga(action) {
    try {
        const response = yield axiosClient.post('/termConditions', action.payload);
        yield put({ type: ADD_TERMS_CONDITIONS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_TERMS_CONDITIONS_FAILURE, payload: error.message });
    }
}

function* watchAddTermsConditions() {
    yield takeLatest(ADD_TERMS_CONDITIONS_PROGRESS, addTermsConditionsSaga);
}

function* editDeleteTermsConditions(action) {
    try {
        const response = yield axiosClient.put(`/termConditions`, action.payload);
        yield put({ type: EDIT_DELETE_TERMS_CONDITIONS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_TERMS_CONDITIONS_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteTermsConditions() {
    yield takeLatest(EDIT_DELETE_TERMS_CONDITIONS_PROGRESS, editDeleteTermsConditions);
}

// ============================= CATEGORY ==============================
function* getCategoryListSaga(action) {
    try {
        const response = yield axiosClient.get(`/category_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_CATEGORY_LIST_SUCCESS, category: response.data });
    } catch (error) {
        yield put({ type: GET_CATEGORY_LIST_FAILURE });
    }
}

function* watchGetCategoryList() {
    yield takeLatest(GET_CATEGORY_LIST_PROGRESS, getCategoryListSaga);
}

function* addCategorySaga(action) {
    try {
        const response = yield axiosClient.post('/category', action.payload);
        yield put({ type: ADD_CATEGORY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CATEGORY_FAILURE, payload: error.message });
    }
}

function* watchAddCategory() {
    yield takeLatest(ADD_CATEGORY_PROGRESS, addCategorySaga);
}

function* editDeleteCategory(action) {
    try {
        const response = yield axiosClient.put(`/category_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_CATEGORY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CATEGORY_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCategory() {
    yield takeLatest(EDIT_DELETE_CATEGORY_PROGRESS, editDeleteCategory);
}

// ============================= CUSTOMER ==============================
function* getCustomerListSaga(action) {
    try {
        const response = yield axiosClient.get(`/customer_list?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_CUSTOMER_LIST_SUCCESS, customer: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_LIST_FAILURE });
    }
}

function* watchGetCustomerList() {
    yield takeLatest(GET_CUSTOMER_LIST_PROGRESS, getCustomerListSaga);
}

function* addCustomerSaga(action) {
    try {
        const response = yield axiosClient.post('/customer', action.payload);
        yield put({ type: ADD_CUSTOMER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CUSTOMER_FAILURE, payload: error.message });
    }
}

function* watchAddCustomer() {
    yield takeLatest(ADD_CUSTOMER_PROGRESS, addCustomerSaga);
}

function* editDeleteCustomer(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/customer_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_CUSTOMER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CUSTOMER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCustomer() {
    yield takeLatest(EDIT_DELETE_CUSTOMER_PROGRESS, editDeleteCustomer);
}

// ============================= Supplier ==============================
function* getSupplierListSaga(action) {
    try {
        const response = yield axiosClient.get(`/supplier_list?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_SUPPLIER_LIST_SUCCESS, supplier: response.data });
    } catch (error) {
        yield put({ type: GET_SUPPLIER_LIST_FAILURE });
    }
}

function* watchGetSupplierList() {
    yield takeLatest(GET_SUPPLIER_LIST_PROGRESS, getSupplierListSaga);
}

function* addSupplierSaga(action) {
    try {
        const response = yield axiosClient.post('/supplier', action.payload);
        yield put({ type: ADD_SUPPLIER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_SUPPLIER_FAILURE, payload: error.message });
    }
}

function* watchAddSupplier() {
    yield takeLatest(ADD_SUPPLIER_PROGRESS, addSupplierSaga);
}

function* editDeleteSupplier(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/supplier_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_SUPPLIER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_SUPPLIER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteSupplier() {
    yield takeLatest(EDIT_DELETE_SUPPLIER_PROGRESS, editDeleteSupplier);
}

// ============================= Customer and Supplier List ==============================
function* getCNSListSaga(action) {
    try {
        const response = yield axiosClient.get(`/CNS_list?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}&&financialYear=${action.payload.financialYear}`);
        yield put({ type: GET_CNS_LIST_SUCCESS, CNS: response.data });
    } catch (error) {
        yield put({ type: GET_CNS_LIST_FAILURE });
    }
}

function* watchGetCNSList() {
    yield takeLatest(GET_CNS_LIST_PROGRESS, getCNSListSaga);
}

function* addCNSSaga(action) {
    try {
        const response = yield axiosClient.post('/CNS', action.payload);
        yield put({ type: ADD_CNS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CNS_FAILURE, payload: error.message });
    }
}

function* watchAddCNS() {
    yield takeLatest(ADD_CNS_PROGRESS, addCNSSaga);
}

function* editDeleteCNS(action) {
    try {
        const response = yield axiosClient.put(`/CNS_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_CNS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CNS_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCNS() {
    yield takeLatest(EDIT_DELETE_CNS_PROGRESS, editDeleteCNS);
}

//  =============================Settings ============================
// ============================= Company Deatails ==============================
function* getCompanyListSaga(action) {
    try {
        const response = yield axiosClient.get(`/companyDetails_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_COMPANY_DETAILS_LIST_SUCCESS, company: response.data });
    } catch (error) {
        yield put({ type: GET_COMPANY_DETAILS_LIST_FAILURE });
    }
}

function* watchGetCompanyList() {
    yield takeLatest(GET_COMPANY_DETAILS_LIST_PROGRESS, getCompanyListSaga);
}

function* addCompanySaga(action) {
    try {
        const response = yield axiosClient.post('/companyDetails', action.payload);
        yield put({ type: ADD_COMPANY_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_COMPANY_DETAILS_FAILURE, payload: error.message });
    }
}

function* watchAddCompany() {
    yield takeLatest(ADD_COMPANY_DETAILS_PROGRESS, addCompanySaga);
}

function* editDeleteCompany(action) {
    try {

        const response = yield axiosClient.put(`/companyDetails`, action.payload);
        yield put({ type: EDIT_DELETE_COMPANY_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_COMPANY_DETAILS_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCompany() {
    yield takeLatest(EDIT_DELETE_COMPANY_DETAILS_PROGRESS, editDeleteCompany);
}
// ============================= Document No Formate ==============================
function* getDocNoFormateAvailableSaga(action) {
    try {
        const response = yield axiosClient.get(`/document_format_available?companyId=${action.payload.companyId}&&documentTypeName='${action.payload.documentTypeName}'`);
        yield put({ type: GET_DOC_NO_FORMATE_AVAILABLE_SUCCESS, docNoFormateAvailable: response.data });
    } catch (error) {
        yield put({ type: GET_DOC_NO_FORMATE_AVAILABLE_FAILURE });
    }
}

function* watchGetDocNoFormateAvailable() {
    yield takeLatest(GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS, getDocNoFormateAvailableSaga);
}

function* getDocNoFormateListSaga(action) {
    try {
        const response = yield axiosClient.get(`/document_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_DOC_NO_FORMATE_LIST_SUCCESS, docNoFormate: response.data });
    } catch (error) {
        yield put({ type: GET_DOC_NO_FORMATE_LIST_FAILURE });
    }
}

function* watchGetDocNoFormateList() {
    yield takeLatest(GET_DOC_NO_FORMATE_LIST_PROGRESS, getDocNoFormateListSaga);
}

function* addDocNoFormateSaga(action) {
    try {
        const response = yield axiosClient.post('/document', action.payload);
        yield put({ type: ADD_DOC_NO_FORMATE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_DOC_NO_FORMATE_FAILURE, payload: error.message });
    }
}

function* watchAddDocNoFormate() {
    yield takeLatest(ADD_DOC_NO_FORMATE_PROGRESS, addDocNoFormateSaga);
}

function* editDeleteDocNoFormate(action) {
    try {
        const response = yield axiosClient.put(`/document_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_DOC_NO_FORMATE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_DOC_NO_FORMATE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteDocNoFormate() {
    yield takeLatest(EDIT_DELETE_DOC_NO_FORMATE_PROGRESS, editDeleteDocNoFormate);
}

// ============================= Invoice Setting ==============================
function* getInvoiceSettingListSaga(action) {
    try {
        const response = yield axiosClient.get(`/invoiceSetting_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_INVOICE_SETTING_LIST_SUCCESS, invoiceSetting: response.data });
    } catch (error) {
        yield put({ type: GET_INVOICE_SETTING_LIST_FAILURE });
    }
}

function* watchGetInvoiceSettingList() {
    yield takeLatest(GET_INVOICE_SETTING_LIST_PROGRESS, getInvoiceSettingListSaga);
}

function* addInvoiceSettingSaga(action) {
    try {
        const response = yield axiosClient.post('/invoiceSetting', action.payload);
        yield put({ type: ADD_INVOICE_SETTING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_INVOICE_SETTING_FAILURE, payload: error.message });
    }
}

function* watchAddInvoiceSetting() {
    yield takeLatest(ADD_INVOICE_SETTING_PROGRESS, addInvoiceSettingSaga);
}

function* editDeleteInvoiceSetting(action) {
    try {
        const response = yield axiosClient.put(`/invoiceSetting_edit`, action.payload);
        yield put({ type: EDIT_DELETE_INVOICE_SETTING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_INVOICE_SETTING_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteInvoiceSetting() {
    yield takeLatest(EDIT_DELETE_INVOICE_SETTING_PROGRESS, editDeleteInvoiceSetting);
}

// ============================= Menu Setting ==============================
function* getMenuSettingListSaga(action) {
    try {
        const response = yield axiosClient.get(`/menuSetting_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_MENU_SETTING_LIST_SUCCESS, menuSetting: response.data });
    } catch (error) {
        yield put({ type: GET_MENU_SETTING_LIST_FAILURE });
    }
}

function* watchGetMenuSettingList() {
    yield takeLatest(GET_MENU_SETTING_LIST_PROGRESS, getMenuSettingListSaga);
}

function* addMenuSettingSaga(action) {
    try {
        const response = yield axiosClient.post('/menuSetting', action.payload);
        yield put({ type: ADD_MENU_SETTING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_MENU_SETTING_FAILURE, payload: error.message });
    }
}

function* watchAddMenuSetting() {
    yield takeLatest(ADD_MENU_SETTING_PROGRESS, addMenuSettingSaga);
}

function* editDeleteMenuSetting(action) {
    try {
        const response = yield axiosClient.put(`/menuSetting_edit`, action.payload);
        yield put({ type: EDIT_DELETE_MENU_SETTING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_MENU_SETTING_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteMenuSetting() {
    yield takeLatest(EDIT_DELETE_MENU_SETTING_PROGRESS, editDeleteMenuSetting);
}

// ============================= Invoice Title ==============================
function* getInvoiceTitleListSaga(action) {
    try {
        const response = yield axiosClient.get(`/invoicePrintTitle_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_INVOICE_TITLE_LIST_SUCCESS, invoicePrintTitle: response.data });
    } catch (error) {
        yield put({ type: GET_INVOICE_TITLE_LIST_FAILURE });
    }
}

function* watchGetInvoiceTitleList() {
    yield takeLatest(GET_INVOICE_TITLE_LIST_PROGRESS, getInvoiceTitleListSaga);
}

function* addInvoiceTitleSaga(action) {
    try {
        const response = yield axiosClient.post('/invoicePrintTitle', action.payload);
        yield put({ type: ADD_INVOICE_TITLE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_INVOICE_TITLE_FAILURE, payload: error.message });
    }
}

function* watchAddInvoiceTitle() {
    yield takeLatest(ADD_INVOICE_TITLE_PROGRESS, addInvoiceTitleSaga);
}

function* editDeleteInvoiceTitle(action) {
    try {
        const response = yield axiosClient.put(`/invoicePrintTitle_edit`, action.payload);
        yield put({ type: EDIT_DELETE_INVOICE_TITLE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_INVOICE_TITLE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteInvoiceTitle() {
    yield takeLatest(EDIT_DELETE_INVOICE_TITLE_PROGRESS, editDeleteInvoiceTitle);
}

// ============================= Purchase Setting ==============================
function* getPurchaseSettingListSaga(action) {
    try {
        const response = yield axiosClient.get(`/bank_list?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_PURCHASE_SETTING_LIST_SUCCESS, purchaseSetting: response.data });
    } catch (error) {
        yield put({ type: GET_PURCHASE_SETTING_LIST_FAILURE });
    }
}

function* watchGetPurchaseSettingList() {
    yield takeLatest(GET_PURCHASE_SETTING_LIST_PROGRESS, getPurchaseSettingListSaga);
}

function* addPurchaseSettingSaga(action) {
    try {
        const response = yield axiosClient.post('/bank', action.payload);
        yield put({ type: ADD_PURCHASE_SETTING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PURCHASE_SETTING_FAILURE, payload: error.message });
    }
}

function* watchAddPurchaseSetting() {
    yield takeLatest(ADD_PURCHASE_SETTING_PROGRESS, addPurchaseSettingSaga);
}

function* editDeletePurchaseSetting(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/bank_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_PURCHASE_SETTING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PURCHASE_SETTING_FAILURE, payload: error.message });
    }
}

function* watchEditDeletePurchaseSetting() {
    yield takeLatest(EDIT_DELETE_PURCHASE_SETTING_PROGRESS, editDeletePurchaseSetting);
}

// ============================= User Management ==============================
function* getAllUserManagementListSaga(action) {
    try {
        const response = yield axiosClient.get(`/allUsers?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_ALL_USER_MANAGEMENT_LIST_SUCCESS, userManagement: response.data });
    } catch (error) {
        yield put({ type: GET_ALL_USER_MANAGEMENT_LIST_FAILURE });
    }
}

function* watchGetAllUserManagementList() {
    yield takeLatest(GET_ALL_USER_MANAGEMENT_LIST_PROGRESS, getAllUserManagementListSaga);
}
function* getUserManagementListSaga(action) {
    try {
        const response = yield axiosClient.get(`/users_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_USER_MANAGEMENT_LIST_SUCCESS, userManagement: response.data });
    } catch (error) {
        yield put({ type: GET_USER_MANAGEMENT_LIST_FAILURE });
    }
}

function* watchGetUserManagementList() {
    yield takeLatest(GET_USER_MANAGEMENT_LIST_PROGRESS, getUserManagementListSaga);
}
function* addUserManagementSaga(action) {
    try {
        const response = yield axiosClient.post('/users', action.payload);
        yield put({ type: ADD_USER_MANAGEMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_USER_MANAGEMENT_FAILURE, payload: error.message });
    }
}

function* watchAddUserManagement() {
    yield takeLatest(ADD_USER_MANAGEMENT_PROGRESS, addUserManagementSaga);
}

function* editDeleteUserManagement(action) {
    try {
        const response = yield axiosClient.put(`/users_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_USER_MANAGEMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_USER_MANAGEMENT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteUserManagement() {
    yield takeLatest(EDIT_DELETE_USER_MANAGEMENT_PROGRESS, editDeleteUserManagement);
}


//  ============================ Purchase ==================================
// ============================= Purchase Order ==============================
function* getPurchaseOrderListSaga(action) {
    try {
        const response = yield axiosClient.get(`/purchase_order_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_PURCHASE_ORDER_LIST_SUCCESS, purchaseOrder: response.data });
    } catch (error) {
        yield put({ type: GET_PURCHASE_ORDER_LIST_FAILURE });
    }
}

function* watchGetPurchaseOrderList() {
    yield takeLatest(GET_PURCHASE_ORDER_LIST_PROGRESS, getPurchaseOrderListSaga);
}

function* addPurchaseOrderSaga(action) {
    try {
        const response = yield axiosClient.post('/purchaseOrder', action.payload);
        yield put({ type: ADD_PURCHASE_ORDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PURCHASE_ORDER_FAILURE, payload: error.message });
    }
}

function* watchAddPurchaseOrder() {
    yield takeLatest(ADD_PURCHASE_ORDER_PROGRESS, addPurchaseOrderSaga);
}

function* editDeletePurchaseOrder(action) {
    try {

        const response = yield axiosClient.put(`/purchase_order_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_PURCHASE_ORDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PURCHASE_ORDER_FAILURE, payload: error.message });
    }
}

function* watchEditDeletePurchaseOrder() {
    yield takeLatest(EDIT_DELETE_PURCHASE_ORDER_PROGRESS, editDeletePurchaseOrder);
}
// ============================= Purchase Invoice ==============================
function* getPurchaseInvoiceListSaga(action) {
    try {
        const response = yield axiosClient.get(`/purchase_invoice_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_PURCHASE_INVOICE_LIST_SUCCESS, purchaseInvoice: response.data });
    } catch (error) {
        yield put({ type: GET_PURCHASE_INVOICE_LIST_FAILURE });
    }
}

function* watchGetPurchaseInvoiceList() {
    yield takeLatest(GET_PURCHASE_INVOICE_LIST_PROGRESS, getPurchaseInvoiceListSaga);
}

function* addPurchaseInvoiceSaga(action) {
    try {
        const response = yield axiosClient.post('/purchaseInvoice', action.payload);
        yield put({ type: ADD_PURCHASE_INVOICE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PURCHASE_INVOICE_FAILURE, payload: error.message });
    }
}

function* watchAddPurchaseInvoice() {
    yield takeLatest(ADD_PURCHASE_INVOICE_PROGRESS, addPurchaseInvoiceSaga);
}

function* editDeletePurchaseInvoice(action) {
    try {
        const response = yield axiosClient.put(`/purchase_invoice_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_PURCHASE_INVOICE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PURCHASE_INVOICE_FAILURE, payload: error.message });
    }
}

function* watchEditDeletePurchaseInvoice() {
    yield takeLatest(EDIT_DELETE_PURCHASE_INVOICE_PROGRESS, editDeletePurchaseInvoice);
}

// ============================= Purchase Return / Debit Note ==============================

function* getPurchaseReturnListSaga(action) {
    try {
        const response = yield axiosClient.get(`/debitNote_list?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_PURCHASE_RETURN_LIST_SUCCESS, purchaseReturn: response.data });
    } catch (error) {
        yield put({ type: GET_PURCHASE_RETURN_LIST_FAILURE });
    }
}

function* watchGetPurchaseReturnList() {
    yield takeLatest(GET_PURCHASE_RETURN_LIST_PROGRESS, getPurchaseReturnListSaga);
}

function* addPurchaseReturnSaga(action) {
    try {
        const response = yield axiosClient.post('/debitNote', action.payload);
        yield put({ type: ADD_PURCHASE_RETURN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PURCHASE_RETURN_FAILURE, payload: error.message });
    }
}

function* watchAddPurchaseReturn() {
    yield takeLatest(ADD_PURCHASE_RETURN_PROGRESS, addPurchaseReturnSaga);
}

function* editDeletePurchaseReturn(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/debitNote_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_PURCHASE_RETURN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PURCHASE_RETURN_FAILURE, payload: error.message });
    }
}

function* watchEditDeletePurchaseReturn() {
    yield takeLatest(EDIT_DELETE_PURCHASE_RETURN_PROGRESS, editDeletePurchaseReturn);
}


//  ============================ Sales ==================================
// ============================= Delivery Challan  ==============================
function* getDeliveryChallanListSaga(action) {
    try {
        const response = yield axiosClient.get(`/sales_delivery_challan_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_DELIVERY_CHALLAN_LIST_SUCCESS, deliveryChallan: response.data });
    } catch (error) {
        yield put({ type: GET_DELIVERY_CHALLAN_LIST_FAILURE });
    }
}

function* watchGetDeliveryChallanList() {
    yield takeLatest(GET_DELIVERY_CHALLAN_LIST_PROGRESS, getDeliveryChallanListSaga);
}

function* addDeliveryChallanSaga(action) {
    try {
        const response = yield axiosClient.post('/sales_delivery_challan', action.payload);
        yield put({ type: ADD_DELIVERY_CHALLAN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_DELIVERY_CHALLAN_FAILURE, payload: error.message });
    }
}

function* watchAddDeliveryChallan() {
    yield takeLatest(ADD_DELIVERY_CHALLAN_PROGRESS, addDeliveryChallanSaga);
}

function* editDeleteDeliveryChallan(action) {
    try {
        const response = yield axiosClient.put(`/sales_delivery_challan_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_DELIVERY_CHALLAN_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteDeliveryChallan() {
    yield takeLatest(EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS, editDeleteDeliveryChallan);
}


function* getDeliveryChallan_ItemDescription_forManualEntry_ListSaga(action) {
    try {
        const response = yield axiosClient.get(`/deliveryChallan_itemDescription_forManualEntry?companyId=${action.payload.companyId}&&customerName=${action.payload.customerName}`);
        yield put({ type: GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, deliveryChallan_itemDescription_forManualEntry: response.data });
    } catch (error) {
        yield put({ type: GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE });
    }
}

function* watchGetDeliveryChallan_ItemDescription_forManualEntry_List() {
    yield takeLatest(GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, getDeliveryChallan_ItemDescription_forManualEntry_ListSaga);
}
// ============================= Proforma Invoice ==============================
function* getProformaInvoiceListSaga(action) {
    try {
        const response = yield axiosClient.get(`/proforma_invoice_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_PROFORMA_INVOICE_LIST_SUCCESS, ProformaInvoice: response.data });
    } catch (error) {
        yield put({ type: GET_PROFORMA_INVOICE_LIST_FAILURE });
    }
}

function* watchGetProformaInvoiceList() {
    yield takeLatest(GET_PROFORMA_INVOICE_LIST_PROGRESS, getProformaInvoiceListSaga);
}

function* addProformaInvoiceSaga(action) {
    try {
        const response = yield axiosClient.post('/proforma_invoice', action.payload);
        yield put({ type: ADD_PROFORMA_INVOICE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PROFORMA_INVOICE_FAILURE, payload: error.message });
    }
}

function* watchAddProformaInvoice() {
    yield takeLatest(ADD_PROFORMA_INVOICE_PROGRESS, addProformaInvoiceSaga);
}

function* editDeleteProformaInvoice(action) {
    try {
        const response = yield axiosClient.put(`/proforma_invoice_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_PROFORMA_INVOICE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PROFORMA_INVOICE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteProformaInvoice() {
    yield takeLatest(EDIT_DELETE_PROFORMA_INVOICE_PROGRESS, editDeleteProformaInvoice);
}

function* getProforma_ItemDescription_forManualEntry_ListSaga(action) {
    try {
        const response = yield axiosClient.get(`/proforma_invoice_itemDescription_forManualEntry?companyId=${action.payload.companyId}&&customerName=${action.payload.customerName}`);
        yield put({ type: GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, proforma_itemDescription_forManualEntry: response.data });
    } catch (error) {
        yield put({ type: GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE });
    }
}

function* watchGetProforma_ItemDescription_forManualEntry_List() {
    yield takeLatest(GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, getProforma_ItemDescription_forManualEntry_ListSaga);
}

// ============================= Quotation ==============================
function* getQuotationListSaga(action) {
    try {
        const response = yield axiosClient.get(`/sales_quotation_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_QUOTATION_LIST_SUCCESS, quotation: response.data });
    } catch (error) {
        yield put({ type: GET_QUOTATION_LIST_FAILURE });
    }
}

function* watchGetQuotationList() {
    yield takeLatest(GET_QUOTATION_LIST_PROGRESS, getQuotationListSaga);
}

function* addQuotationSaga(action) {
    try {
        const response = yield axiosClient.post('/sales_quotation', action.payload);
        yield put({ type: ADD_QUOTATION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_QUOTATION_FAILURE, payload: error.message });
    }
}

function* watchAddQuotation() {
    yield takeLatest(ADD_QUOTATION_PROGRESS, addQuotationSaga);
}

function* editDeleteQuotation(action) {
    try {
        const response = yield axiosClient.put(`/sales_quotation_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_QUOTATION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_QUOTATION_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteQuotation() {
    yield takeLatest(EDIT_DELETE_QUOTATION_PROGRESS, editDeleteQuotation);
}

function* getQuotation_ItemDescription_forManualEntry_ListSaga(action) {
    try {
        const response = yield axiosClient.get(`/quotation_itemDescription_forManualEntry?companyId=${action.payload.companyId}&&customerName=${action.payload.customerName}`);
        yield put({ type: GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, quotation_itemDescription_forManualEntry: response.data });
    } catch (error) {
        yield put({ type: GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE });
    }
}

function* watchGetQuotation_ItemDescription_forManualEntry_List() {
    yield takeLatest(GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, getQuotation_ItemDescription_forManualEntry_ListSaga);
}
// ============================= customer and Supplier Advance Payment ==============================
function* getCNSAdvancePaymentListSaga(action) {
    try {
        const response = yield axiosClient.get(`/advance_supplier_customer_payment_list?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}`);
        yield put({ type: GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_SUCCESS, customer_supplier_advancePayment: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_FAILURE });
    }
}

function* watchGetCNSAdvancePaymentList() {
    yield takeLatest(GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS, getCNSAdvancePaymentListSaga);
}

function* addCNSAdvancePaymentSaga(action) {
    try {
        const response = yield axiosClient.post('/advance_supplier_customer_payment', action.payload);
        yield put({ type: ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE, payload: error.message });
    }
}

function* watchAddCNSAdvancePayment() {
    yield takeLatest(ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS, addCNSAdvancePaymentSaga);
}

function* editDeleteCNSAdvancePayment(action) {
    try {
        const response = yield axiosClient.put(`/advance_supplier_customer_payment`, action.payload);
        yield put({ type: EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCNSAdvancePayment() {
    yield takeLatest(EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS, editDeleteCNSAdvancePayment);
}

// ============================= customer and Supplier Payment ==============================
function* getCNSPaymentListSaga(action) {
    try {
        const response = yield axiosClient.get(`supplier_customer_payment_list?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}`);
        yield put({ type: GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_SUCCESS, customer_supplier_payment: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_FAILURE });
    }
}

function* watchGetCNSPaymentList() {
    yield takeLatest(GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS, getCNSPaymentListSaga);
}

function* addCNSPaymentSaga(action) {
    try {
        const response = yield axiosClient.post('supplier_customer_payment', action.payload);
        yield put({ type: ADD_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CUSTOMER_SUPPLIER_PAYMENT_FAILURE, payload: error.message });
    }
}

function* watchAddCNSPayment() {
    yield takeLatest(ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS, addCNSPaymentSaga);
}

function* editDeleteCNSPayment(action) {
    try {
        const response = yield axiosClient.put(`supplier_customer_payment_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCNSPayment() {
    yield takeLatest(EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS, editDeleteCNSPayment);
}


function* uploadFileAttachmentSaga(action) {
    try {
        const response = yield axiosClient.post('/fileAttachment', action.payload);
        yield put({ type: UPLOAD_FILE_ATTACHMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: UPLOAD_FILE_ATTACHMENT_FAILURE, payload: error.message });
    }
}

function* watchuploadFileAttachment() {
    yield takeLatest(UPLOAD_FILE_ATTACHMENT_PROGRESS, uploadFileAttachmentSaga);
}

function* getCNSPendingPaymentListSaga(action) {
    try {
        const response = yield axiosClient.get(`supplier_customer_pending_payment_list?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}&&CNS_id=${action.payload.CNS_id}`);
        yield put({ type: GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_SUCCESS, customer_supplier_pending_payment: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_FAILURE });
    }
}

function* watchGetCNSPendingPaymentList() {
    yield takeLatest(GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS, getCNSPendingPaymentListSaga);
}

// ============================= Payment INVOICE DEDUCTION ==============================
function* getPaymentInvoiceDeductionSaga(action) {
    try {
        const response = yield axiosClient.get(`/invoice_wise_deduction?companyId=${action.payload.companyId}&&invoice_id=${action.payload.invoice_id}&&CNS_Type=${action.payload.CNS_Type}`);
        yield put({ type: GET_PAYMENT_INVOICE_DEDUCTION_LIST_SUCCESS, paymentInvoiceDeduction: response.data });
    } catch (error) {
        yield put({ type: GET_PAYMENT_INVOICE_DEDUCTION_LIST_FAILURE });
    }
}

function* watchGetPaymentInvoiceDeduction() {
    yield takeLatest(GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS, getPaymentInvoiceDeductionSaga);
}

function* addPaymentInvoiceDeductionSaga(action) {
    try {
        const response = yield axiosClient.post('/deduction', action.payload);
        yield put({ type: ADD_PAYMENT_INVOICE_DEDUCTION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PAYMENT_INVOICE_DEDUCTION_FAILURE, payload: error.message });
    }
}

function* watchAddPaymentInvoiceDeduction() {
    yield takeLatest(ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS, addPaymentInvoiceDeductionSaga);
}

function* editDeletePaymentInvoiceDeduction(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/deduction_edit_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_FAILURE, payload: error.message });
    }
}

function* watchEditDeletePaymentInvoiceDeduction() {
    yield takeLatest(EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS, editDeletePaymentInvoiceDeduction);
}

// ============================= Sale Invoice ==============================
function* getSaleInvoiceListSaga(action) {
    try {
        const response = yield axiosClient.get(`/sales_invoice_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_SALE_INVOICE_LIST_SUCCESS, saleInvoice: response.data });
    } catch (error) {
        yield put({ type: GET_SALE_INVOICE_LIST_FAILURE });
    }
}

function* watchGetSaleInvoiceList() {
    yield takeLatest(GET_SALE_INVOICE_LIST_PROGRESS, getSaleInvoiceListSaga);
}

function* addSaleInvoiceSaga(action) {
    try {
        const response = yield axiosClient.post('/sales_invoice', action.payload);
        yield put({ type: ADD_SALE_INVOICE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_SALE_INVOICE_FAILURE, payload: error.message });
    }
}

function* watchAddSaleInvoice() {
    yield takeLatest(ADD_SALE_INVOICE_PROGRESS, addSaleInvoiceSaga);
}

function* editDeleteSaleInvoice(action) {
    try {

        const response = yield axiosClient.put(`/sales_invoice_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_SALE_INVOICE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_SALE_INVOICE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteSaleInvoice() {
    yield takeLatest(EDIT_DELETE_SALE_INVOICE_PROGRESS, editDeleteSaleInvoice);
}

function* getSales_ItemDescription_forManualEntry_ListSaga(action) {
    try {
        const response = yield axiosClient.get(`/sales_itemDescription_forManualEntry?companyId=${action.payload.companyId}&&customerName=${action.payload.customerName}`);
        yield put({ type: GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, sales_itemDescription_forManualEntry: response.data });
    } catch (error) {
        yield put({ type: GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE });
    }
}

function* watchGetSales_ItemDescription_forManualEntry_List() {
    yield takeLatest(GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, getSales_ItemDescription_forManualEntry_ListSaga);
}

function* getAgeOfUnpaidInvoiceListSaga(action) {
    try {
        const response = yield axiosClient.get(`/ageOf_unpaid_invoice?companyId=${action.payload.companyId}&&customerName=${action.payload.customerName}`);
        yield put({ type: GET_AGE_OF_UNPAID_INVOICE_SUCCESS, ageOf_unpaid_invoice: response.data });
    } catch (error) {
        yield put({ type: GET_AGE_OF_UNPAID_INVOICE_FAILURE });
    }
}

function* watchGetAgeOfUnpaidInvoiceList() {
    yield takeLatest(GET_AGE_OF_UNPAID_INVOICE_PROGRESS, getAgeOfUnpaidInvoiceListSaga);
}
// ============================= Sales Order ==============================
function* getSalesOrderListSaga(action) {
    try {
        const response = yield axiosClient.get(`/sales_order_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_SALES_ORDER_LIST_SUCCESS, salesOrder: response.data });
    } catch (error) {
        yield put({ type: GET_SALES_ORDER_LIST_FAILURE });
    }
}

function* watchGetSalesOrderList() {
    yield takeLatest(GET_SALES_ORDER_LIST_PROGRESS, getSalesOrderListSaga);
}

function* addSalesOrderSaga(action) {
    try {
        const response = yield axiosClient.post('/sales_order', action.payload);
        yield put({ type: ADD_SALES_ORDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_SALES_ORDER_FAILURE, payload: error.message });
    }
}

function* watchAddSalesOrder() {
    yield takeLatest(ADD_SALES_ORDER_PROGRESS, addSalesOrderSaga);
}

function* editDeleteSalesOrder(action) {
    try {

        const response = yield axiosClient.put(`/sales_order_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_SALES_ORDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_SALES_ORDER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteSalesOrder() {
    yield takeLatest(EDIT_DELETE_SALES_ORDER_PROGRESS, editDeleteSalesOrder);
}

function* getSalesOrder_ItemDescription_forManualEntry_ListSaga(action) {
    try {
        const response = yield axiosClient.get(`/salesOrder_itemDescription_forManualEntry?companyId=${action.payload.companyId}&&customerName=${action.payload.customerName}`);
        yield put({ type: GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS, salesOrder_itemDescription_forManualEntry: response.data });
    } catch (error) {
        yield put({ type: GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE });
    }
}

function* watchGetSalesOrder_ItemDescription_forManualEntry_List() {
    yield takeLatest(GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, getSalesOrder_ItemDescription_forManualEntry_ListSaga);
}

// ============================= Sales Return ==============================
function* getSalesReturnListSaga(action) {
    try {
        const response = yield axiosClient.get(`/creditNote_list?companyId=${action.payload.companyInfo}`);
        yield put({ type: GET_SALES_RETURN_LIST_SUCCESS, salesReturn: response.data });
    } catch (error) {
        yield put({ type: GET_SALES_RETURN_LIST_FAILURE });
    }
}

function* watchGetSalesReturnList() {
    yield takeLatest(GET_SALES_RETURN_LIST_PROGRESS, getSalesReturnListSaga);
}

function* addSalesReturnSaga(action) {
    try {
        const response = yield axiosClient.post('/creditNote', action.payload);
        yield put({ type: ADD_SALES_RETURN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_SALES_RETURN_FAILURE, payload: error.message });
    }
}

function* watchAddSalesReturn() {
    yield takeLatest(ADD_SALES_RETURN_PROGRESS, addSalesReturnSaga);
}

function* editDeleteSalesReturn(action) {
    try {
        const data = {
            ...action.payload
        };
        const response = yield axiosClient.put(`/creditNote_delete?_id=${data._id}`, data);
        yield put({ type: EDIT_DELETE_SALES_RETURN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_SALES_RETURN_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteSalesReturn() {
    yield takeLatest(EDIT_DELETE_SALES_RETURN_PROGRESS, editDeleteSalesReturn);
}
// ============================= States ==============================
function* getStateListSaga(action) {
    try {
        const response = yield axiosClient.get(`/states`);
        yield put({ type: GET_STATES_LIST_SUCCESS, allStates: response.data });
    } catch (error) {
        yield put({ type: GET_STATES_LIST_FAILURE });
    }
}

function* watchGetStateList() {
    yield takeLatest(GET_STATES_LIST_PROGRESS, getStateListSaga);
}

// =========== All Reports===========

// ----------- sales Register -----
function* getSalesRegisterReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/sales_register_report?companyId=${action.payload.companyId}&&CNS_id=${action.payload.CNS_id}&&fromDate=${action.payload.fromDate}&&toDate=${action.payload.toDate}`);
        yield put({ type: GET_SALES_REGISTER_REPORT_SUCCESS, salesRegister: response.data });
    } catch (error) {
        yield put({ type: GET_SALES_REGISTER_REPORT_FAILURE });
    }
}

function* watchGetSalesRegisterReport() {
    yield takeLatest(GET_SALES_REGISTER_REPORT_PROGRESS, getSalesRegisterReportSaga);
}

// ----------- Purchase Register -------------
function* getPurchaseRegisterReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/purchase_register_report?companyId=${action.payload.companyId}&&CNS_id=${action.payload.CNS_id}&&fromDate=${action.payload.fromDate}&&toDate=${action.payload.toDate}`);
        yield put({ type: GET_PURCHASE_REGISTER_REPORT_SUCCESS, purchaseRegister: response.data });
    } catch (error) {
        yield put({ type: GET_PURCHASE_REGISTER_REPORT_FAILURE });
    }
}

function* watchGetPurchaseRegisterReport() {
    yield takeLatest(GET_PURCHASE_REGISTER_REPORT_PROGRESS, getPurchaseRegisterReportSaga);
}

// ----------- Sales Order History -------------
function* getSalesOrderHistoryReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/sales_order_history_report?companyId=${action.payload.companyId}&&CNS_id=${action.payload.CNS_id}&&fromDate=${action.payload.fromDate}&&toDate=${action.payload.toDate}`);
        yield put({ type: GET_SALES_ORDER_HISTORY_REPORT_SUCCESS, salesOrderHistory: response.data });
    } catch (error) {
        yield put({ type: GET_SALES_ORDER_HISTORY_REPORT_FAILURE });
    }
}

function* watchGetSalesOrderHistoryReport() {
    yield takeLatest(GET_SALES_ORDER_HISTORY_REPORT_PROGRESS, getSalesOrderHistoryReportSaga);
}

// ----------- Purchase Order History -------------
function* getPurchaseOrderHistoryReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/purchase_order_history_report?companyId=${action.payload.companyId}&&CNS_id=${action.payload.CNS_id}&&fromDate=${action.payload.fromDate}&&toDate=${action.payload.toDate}`);
        yield put({ type: GET_PURCHASE_ORDER_HISTORY_REPORT_SUCCESS, purchaseOrderHistory: response.data });
    } catch (error) {
        yield put({ type: GET_PURCHASE_ORDER_HISTORY_REPORT_FAILURE });
    }
}

function* watchGetPurchaseOrderHistoryReport() {
    yield takeLatest(GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS, getPurchaseOrderHistoryReportSaga);
}

// ----------- Account Statement ---------
function* getAccountStatementReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/account_statement_report?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}&&CNS_id=${action.payload.CNS_id}&&fromDate=${action.payload.fromDate}&&toDate=${action.payload.toDate}`);
        yield put({ type: GET_ACCOUNT_STATEMENT_REPORT_SUCCESS, accountStatement: response.data });
    } catch (error) {
        yield put({ type: GET_ACCOUNT_STATEMENT_REPORT_FAILURE });
    }
}

function* watchGetAccountStatementReport() {
    yield takeLatest(GET_ACCOUNT_STATEMENT_REPORT_PROGRESS, getAccountStatementReportSaga);
}

// ----------- Payment Register -------------

function* getPaymentRegisterReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/payment_register_report?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}&&CNS_id=${action.payload.CNS_id}&&fromDate=${action.payload.fromDate}&&toDate=${action.payload.toDate}`);
        yield put({ type: GET_PAYMENT_REGISTER_REPORT_SUCCESS, paymentRegister: response.data });
    } catch (error) {
        yield put({ type: GET_PAYMENT_REGISTER_REPORT_FAILURE });
    }
}

function* watchGetPaymentRegisterReport() {
    yield takeLatest(GET_PAYMENT_REGISTER_REPORT_PROGRESS, getPaymentRegisterReportSaga);
}

// ----------- Outstanding Report -------------

function* getOutstandingReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/outstanding_report?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}&&CNS_id=${action.payload.CNS_id}&&filterOption=${action.payload.filterOption}`);
        yield put({ type: GET_OUTSTANDING_REPORT_SUCCESS, outstanding: response.data });
    } catch (error) {
        yield put({ type: GET_OUTSTANDING_REPORT_FAILURE });
    }
}

function* watchGetOutstandingReport() {
    yield takeLatest(GET_OUTSTANDING_REPORT_PROGRESS, getOutstandingReportSaga);
}

// ----------- GST Register Report -------------

function* getGSTRegisterReportSaga(action) {
    try {
        const response = yield axiosClient.get(`/gst_register_report?companyId=${action.payload.companyId}&&CNS_Type=${action.payload.CNS_Type}&&CNS_id=${action.payload.CNS_id}&&fromDate=${action.payload.fromDate}&&toDate=${action.payload.toDate}`);
        yield put({ type: GET_GST_REGESTER_REPORT_SUCCESS, GSTRegister: response.data });
    } catch (error) {
        yield put({ type: GET_GST_REGESTER_REPORT_FAILURE });
    }
}

function* watchGetGSTRegisterReport() {
    yield takeLatest(GET_GST_REGESTER_REPORT_PROGRESS, getGSTRegisterReportSaga);
}

// UPLOAD EXCEL SHEET 

function* uploadBankDataSaga(action) {
    try {
        const response = yield axiosClient.post('/bank/upload', action.payload);
        yield put({ type: UPLOAD_BANK_EXCEL_SUCCESS, payload: response.data.result });
    } catch (error) {
        yield put({ type: UPLOAD_BANK_EXCEL_FAILURE, payload: error.message });
    }
}

function* watchUploadBankData() {
    yield takeLatest(UPLOAD_BANK_EXCEL_PROGRESS, uploadBankDataSaga);
}

function* uploadCNSDataSaga(action) {
    try {
        const response = yield axiosClient.post('/CNS/upload', action.payload);
        yield put({ type: UPLOAD_CNS_EXCEL_SUCCESS, payload: response.data.result });
    } catch (error) {
        yield put({ type: UPLOAD_CNS_EXCEL_FAILURE, payload: error.message });
    }
}

function* watchUploadCNSData() {
    yield takeLatest(UPLOAD_CNS_EXCEL_PROGRESS, uploadCNSDataSaga);
}

function* uploadItemDataSaga(action) {
    try {
        const response = yield axiosClient.post('/items/upload', action.payload);
        yield put({ type: UPLOAD_ITEMS_EXCEL_SUCCESS, payload: response.data.result });
    } catch (error) {
        yield put({ type: UPLOAD_ITEMS_EXCEL_FAILURE, payload: error.message });
    }
}

function* watchUploadItemData() {
    yield takeLatest(UPLOAD_ITEMS_EXCEL_PROGRESS, uploadItemDataSaga);
}

function* uploadUserDataSaga(action) {
    try {
        const response = yield axiosClient.post('/users/upload', action.payload);
        yield put({ type: UPLOAD_USER_EXCEL_SUCCESS, payload: response.data.result });
    } catch (error) {
        yield put({ type: UPLOAD_USER_EXCEL_FAILURE, payload: error.message });
    }
}

function* watchUploadUserData() {
    yield takeLatest(UPLOAD_USER_EXCEL_PROGRESS, uploadUserDataSaga);
}

//   Print Setup 
function* getPrintSetupListSaga(action) {
    try {
        const response = yield axiosClient.get(`/printSetup_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_PRINT_SETUP_LIST_SUCCESS, printSetup: response.data });
    } catch (error) {
        yield put({ type: GET_PRINT_SETUP_LIST_FAILURE });
    }
}

function* watchGetPrintSetupList() {
    yield takeLatest(GET_PRINT_SETUP_LIST_PROGRESS, getPrintSetupListSaga);
}

function* addPrintSetupSaga(action) {
    try {
        const response = yield axiosClient.post('/printSetup', action.payload);
        yield put({ type: ADD_PRINT_SETUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PRINT_SETUP_FAILURE, payload: error.message });
    }
}

function* watchAddPrintSetup() {
    yield takeLatest(ADD_PRINT_SETUP_PROGRESS, addPrintSetupSaga);
}

function* editDeletePrintSetup(action) {
    try {
        const response = yield axiosClient.put(`/printSetup_edit`, action.payload);
        yield put({ type: EDIT_DELETE_PRINT_SETUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PRINT_SETUP_FAILURE, payload: error.message });
    }
}

function* watchEditDeletePrintSetup() {
    yield takeLatest(EDIT_DELETE_PRINT_SETUP_PROGRESS, editDeletePrintSetup);
}

function* uploadAttachmentWatermarkSaga(action) {
    try {
        const response = yield axiosClient.post('/printSetupAttachment/watermark', action.payload);
        yield put({ type: WATERMARK_PRINT_SETUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: WATERMARK_PRINT_SETUP_FAILURE, payload: error.message });
    }
}

function* watchuploadAttachmentWatermark() {
    yield takeLatest(WATERMARK_PRINT_SETUP_PROGRESS, uploadAttachmentWatermarkSaga);
}

function* uploadAttachmentFooterSaga(action) {
    try {
        const response = yield axiosClient.post('/printSetupAttachment/footer', action.payload);
        yield put({ type: FOOTER_PRINT_SETUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FOOTER_PRINT_SETUP_FAILURE, payload: error.message });
    }
}

function* watchuploadAttachmentFooter() {
    yield takeLatest(FOOTER_PRINT_SETUP_PROGRESS, uploadAttachmentFooterSaga);
}

function* uploadAttachmentSignatureSaga(action) {
    try {
        const response = yield axiosClient.post('/printSetupAttachment/signature', action.payload);
        yield put({ type: SIGNATURE_PRINT_SETUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SIGNATURE_PRINT_SETUP_FAILURE, payload: error.message });
    }
}

function* watchuploadAttachmentSignature() {
    yield takeLatest(SIGNATURE_PRINT_SETUP_PROGRESS, uploadAttachmentSignatureSaga);
}

// Dashboard 
function* getTotalReceivablePayableDashboard(action) {
    try {
        const response = yield axiosClient.get(`/getTotalReceivableAndPayable?companyId=${action.payload.companyId}&&financialYear=${action.payload.financialYear}`);
        yield put({ type: GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_SUCCESS, totalReceivablePayableDashboard: response.data });
    } catch (error) {
        yield put({ type: GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_FAILURE });
    }
}

function* watchGetTotalReceivablePayableDashboard() {
    yield takeLatest(GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS, getTotalReceivablePayableDashboard);
}

function* getMonthAndCustomerWiseSalesDashboard(action) {
    try {
        const response = yield axiosClient.get(`/getMonthAndCustomerWiseSales?companyId=${action.payload.companyId}&&financialYear=${action.payload.financialYear}&&selectedOption=${action.payload.selectedOption}`);
        yield put({ type: GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_SUCCESS, MonthAndCustomerWiseSalesDashboard: response.data });
    } catch (error) {
        yield put({ type: GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_FAILURE });
    }
}

function* watchGetMonthAndCustomerWiseSalesDashboard() {
    yield takeLatest(GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS, getMonthAndCustomerWiseSalesDashboard);
}

function* getMonthAndCustomerWisePurchaseDashboard(action) {
    try {
        const response = yield axiosClient.get(`/getMonthAndCustomerWisePurchase?companyId=${action.payload.companyId}&&financialYear=${action.payload.financialYear}&&selectedOption=${action.payload.selectedOption}`);
        yield put({ type: GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_SUCCESS, MonthAndCustomerWisePurchaseDashboard: response.data });
    } catch (error) {
        yield put({ type: GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_FAILURE });
    }
}

function* watchGetMonthAndCustomerWisePurchaseDashboard() {
    yield takeLatest(GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS, getMonthAndCustomerWisePurchaseDashboard);
}

// ============================= Production ==============================
function* getProductionListSaga(action) {
    try {
        const response = yield axiosClient.get(`/production_list?companyId=${action.payload.companyId}`);
        yield put({ type: GET_PRODUCTION_LIST_SUCCESS, production: response.data });
    } catch (error) {
        yield put({ type: GET_PRODUCTION_LIST_FAILURE });
    }
}

function* watchGetProductionList() {
    yield takeLatest(GET_PRODUCTION_LIST_PROGRESS, getProductionListSaga);
}

function* addProductionSaga(action) {
    try {
        const response = yield axiosClient.post('/production_entry', action.payload);
        yield put({ type: ADD_PRODUCTION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PRODUCTION_FAILURE, payload: error.message });
    }
}

function* watchAddProduction() {
    yield takeLatest(ADD_PRODUCTION_PROGRESS, addProductionSaga);
}

function* editDeleteProduction(action) {
    try {
        const response = yield axiosClient.put(`/production_edit_delete`, action.payload);
        yield put({ type: EDIT_DELETE_PRODUCTION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PRODUCTION_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteProduction() {
    yield takeLatest(EDIT_DELETE_PRODUCTION_PROGRESS, editDeleteProduction);
}

function* mailSendingAttachmentSaga(action) {
    try {
        const response = yield axiosClient.post('/sendMailWithAttachments', action.payload);
        yield put({ type: MAIL_SEND_ATTACHMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: MAIL_SEND_ATTACHMENT_FAILURE, payload: error.message });
    }
}

function* watchMailSendingAttachment() {
    yield takeLatest(MAIL_SEND_ATTACHMENT_PROGRESS, mailSendingAttachmentSaga);
}

function* getNotificationSaga(action) {
    try {
        const response = yield axiosClient.get(`/get_notifications?companyId=${action.payload.companyId}`);
        yield put({ type: GET_NOTIFICATIONS_SUCCESS, notifications: response.data });
    } catch (error) {
        yield put({ type: GET_NOTIFICATIONS_FAILURE });
    }
}

function* watchGetNotification() {
    yield takeLatest(GET_NOTIFICATIONS_PROGRESS, getNotificationSaga);
}

// Export all sagas
export default function* rootSaga() {
    yield all([
        watchLogin(), watchLogout(), watchMailSendingAttachment(), watchGetNotification(),
        watchUploadBankData(), watchUploadCNSData(), watchUploadItemData(), watchUploadUserData(),
        watchGetBankList(), watchAddBank(), watchEditDeleteBank(),
        watchGetStoreList(), watchAddStore(), watchEditDeleteStore(),
        watchGetUnitList(), watchAddUnit(), watchEditDeleteUnit(),
        watchGetBinList(), watchAddBin(), watchEditDeleteBin(),
        watchGetRejectList(), watchAddReject(), watchEditDeleteReject(),
        watchGetItemList(), watchAddItem(), watchEditDeleteItem(),
        watchGetAccountManagerList(), watchAddAccountManager(), watchEditDeleteAccountManager(),
        watchGetTermsConditionsList(), watchAddTermsConditions(), watchEditDeleteTermsConditions(),
        watchGetCategoryList(), watchAddCategory(), watchEditDeleteCategory(),
        watchGetCustomerList(), watchAddCustomer(), watchEditDeleteCustomer(),
        watchGetSupplierList(), watchAddSupplier(), watchEditDeleteSupplier(),
        watchGetCNSList(), watchAddCNS(), watchEditDeleteCNS(),

        // ====================== Settings ====================
        watchGetCompanyList(), watchAddCompany(), watchEditDeleteCompany(),
        watchGetDocNoFormateList(), watchAddDocNoFormate(), watchEditDeleteDocNoFormate(), watchGetDocNoFormateAvailable(),
        watchGetInvoiceSettingList(), watchAddInvoiceSetting(), watchEditDeleteInvoiceSetting(),
        watchGetMenuSettingList(), watchAddMenuSetting(), watchEditDeleteMenuSetting(),
        watchGetInvoiceTitleList(), watchAddInvoiceTitle(), watchEditDeleteInvoiceTitle(),
        watchGetPurchaseSettingList(), watchAddPurchaseSetting(), watchEditDeletePurchaseSetting(),
        watchGetAllUserManagementList(), watchGetUserManagementList(), watchAddUserManagement(), watchEditDeleteUserManagement(),

        // ====================== Purchase ====================
        watchGetPurchaseInvoiceList(), watchAddPurchaseInvoice(), watchEditDeletePurchaseInvoice(),
        watchGetPurchaseOrderList(), watchAddPurchaseOrder(), watchEditDeletePurchaseOrder(),
        watchGetPurchaseReturnList(), watchAddPurchaseReturn(), watchEditDeletePurchaseReturn(),
        // ====================== Sales ====================
        watchGetDeliveryChallanList(), watchAddDeliveryChallan(), watchEditDeleteDeliveryChallan(), watchGetDeliveryChallan_ItemDescription_forManualEntry_List(),
        watchGetProformaInvoiceList(), watchAddProformaInvoice(), watchEditDeleteProformaInvoice(), watchGetProforma_ItemDescription_forManualEntry_List(),
        watchGetQuotationList(), watchAddQuotation(), watchEditDeleteQuotation(), watchGetQuotation_ItemDescription_forManualEntry_List(),
        watchGetCNSAdvancePaymentList(), watchAddCNSAdvancePayment(), watchEditDeleteCNSAdvancePayment(),
        watchGetCNSPaymentList(), watchAddCNSPayment(), watchEditDeleteCNSPayment(),
        watchuploadFileAttachment(), watchGetCNSPendingPaymentList(), watchGetAgeOfUnpaidInvoiceList(),
        watchGetPaymentInvoiceDeduction(), watchAddPaymentInvoiceDeduction(), watchEditDeletePaymentInvoiceDeduction(),
        watchGetSaleInvoiceList(), watchAddSaleInvoice(), watchEditDeleteSaleInvoice(), watchGetSales_ItemDescription_forManualEntry_List(),
        watchGetSalesOrderList(), watchAddSalesOrder(), watchEditDeleteSalesOrder(), watchGetSalesOrder_ItemDescription_forManualEntry_List(),
        watchGetSalesReturnList(), watchAddSalesReturn(), watchEditDeleteSalesReturn(),
        watchGetStateList(),
        watchGetMailSetupList(), watchAddMailSetup(), watchEditDeleteMailSetup(),
        watchGetSalesRegisterReport(),
        watchGetPurchaseRegisterReport(),
        watchGetSalesOrderHistoryReport(),
        watchGetPurchaseOrderHistoryReport(),
        watchGetAccountStatementReport(),
        watchGetPaymentRegisterReport(),
        watchGetOutstandingReport(),
        watchGetGSTRegisterReport(),
        // Print Setup 
        watchAddPrintSetup(), watchEditDeletePrintSetup(), watchGetPrintSetupList(),
        watchuploadAttachmentWatermark(), watchuploadAttachmentFooter(), watchuploadAttachmentSignature(),
        watchGetTotalReceivablePayableDashboard(),
        watchGetMonthAndCustomerWiseSalesDashboard(),
        watchGetMonthAndCustomerWisePurchaseDashboard(),
        watchAddProduction(), watchGetProductionList(), watchEditDeleteProduction(),
    ])
}